export default "__VITE_ASSET__x3RH0FXL__"